export default __webpack_public_path__ + "static/media/penhole-logo.f4047f45.png";